<template>
  <div>
    <LsModal title="One Time Reschedule Status" track-id="one_time_reschedule_modal">
      <template #body>
        <div>
          <strong>Finding a new crew</strong>
          <p>
            If your provider is not able to accommodate your requested date change we will look for
            a new pro to come out just for this individual service. In the event you were open to
            switching pros permanently this pro may become the permanent pro.
          </p>
          <strong>Waiting on your pro</strong>
          <p>
            We are currently working with your provider to attempt to accommodate your requested day
            change.
          </p>
          <strong>Provider unavailable</strong>
          <p>
            Your pro was not able to accommodate your requested schedule change and you were not
            interested in switching your pro so we will look forward to servicing you on the
            originally scheduled date.
          </p>
        </div>
      </template>
    </LsModal>
  </div>
</template>

<script>
import { LsModal } from '@/components/common';

export default {
  name: 'OneTimeRescheduleModal',
  components: {
    LsModal,
  },
};
</script>

<style lang="scss" scoped>
strong {
  font-size: $size-5;
  color: $gray-primary;
}

p {
  padding: 5px 0 15px 0;
  color: $gray-primary;
}

p:last-of-type {
  padding-bottom: 0;
}

.themed-app {
  strong {
    font-size: $theme-txt-body;
    color: $theme-color-gray-darker;
  }

  p {
    padding: 5px 0 15px 0;
    color: $theme-color-gray-darker;
  }
}
</style>
